import api from "lib/api/api";

export const FETCH_ADMIN_APPROVED_COURSES_REQUEST =
  "FETCH_ADMIN_APPROVED_COURSES_REQUEST";
export const FETCH_ADMIN_APPROVED_COURSES_SUCCESS =
  "FETCH_ADMIN_APPROVED_COURSES_SUCCESS";
export const FETCH_ADMIN_APPROVED_COURSES_FAILURE =
  "FETCH_ADMIN_APPROVED_COURSES_FAILURE";

// adminApprovedCoursesAction.js
// adminApprovedCoursesAction.js
export const fetchAdminApprovedCourses = (courseId, type = null) => async (dispatch) => {
  dispatch({ type: FETCH_ADMIN_APPROVED_COURSES_REQUEST });

  try {
    const endpoint = type
      ? `/admin/approved-by-type/${courseId}?type=${type}`
      : `/admin/approved/${courseId}`;

    const response = await api.get(endpoint);

    dispatch({
      type: FETCH_ADMIN_APPROVED_COURSES_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_ADMIN_APPROVED_COURSES_FAILURE,
      payload:
        error.response?.data?.message || "Failed to fetch approved courses",
    });
  }
};



export const CLEAR_ADMIN_APPROVED_COURSES = "CLEAR_ADMIN_APPROVED_COURSES";
export const clearAdminApprovedCourses = () => ({
  type: CLEAR_ADMIN_APPROVED_COURSES,
});
